// @flow

import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import { getHomePageHead } from '@seek/seek-jobs-seo';

import { SafetyHelmet } from 'src/components/SafetyHelmet/SafetyHelmet';
import Dashboard from './Dashboard/Dashboard';
import ContentSpacer from 'src/components/ContentSpacer/ContentSpacer';
import QuickSearch from './QuickSearch/QuickSearch';
import HomePageBanner from './HomePageBanner/HomePageBanner';

type Props = {
  locale: Locale
};

const mapStateToProps = ({ location }) => ({
  locale: location.locale
});

class HomePage extends PureComponent<Props> {
  props: Props;
  render() {
    const { locale } = this.props;

    return (
      <div>
        <SafetyHelmet {...getHomePageHead(locale)} />
        <Dashboard />
        <ContentSpacer isSlider trigger="dashboard">
          <HomePageBanner />
          <QuickSearch />
        </ContentSpacer>
      </div>
    );
  }
}

export default connect(mapStateToProps)(HomePage);
